import { useQuery } from '@tanstack/react-query';
import { gql, GraphQLClient } from 'graphql-request';
import { getRetryDelayFn } from '../../utils/query/retryDelay';

const MAPLE_API_URL = 'https://api.maple.finance/v2/graphql';

const client = new GraphQLClient(MAPLE_API_URL);

// not sure if dripsYieldBoost will be rewarded to us
const yieldQuery = gql`
	query GetPoolApy {
		poolV2(id: "0x80ac24aa929eaf5013f6436cda2a7ba190f5cc0b") {
			name
			weeklyApy
			monthlyApy
		}
		syrupGlobals {
			dripsYieldBoost
		}
	}
`;

export const useSyrupUsdcFetch = () => {
	return useQuery({
		queryKey: ['syrupUsdcYield'],
		queryFn: async () => {
			const response = await client.request<{
				poolV2: {
					weeklyApy: number;
					monthlyApy: number;
				};
				syrupGlobals: { dripsYieldBoost: number };
			}>(yieldQuery);

			return response;
		},
		staleTime: 10 * 60 * 1000, // 10 minutes
		retryDelay: getRetryDelayFn(2000),
		retry: 3,
	});
};
